import { Component, OnInit, Input } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';

@Component({
  selector: 'app-catalogs-products-breadcrumb-card',
  templateUrl: './catalogs-products-breadcrumb-card.component.html',
  styleUrls: ['./catalogs-products-breadcrumb-card.component.scss']
})
export class CatalogsProductsBreadcrumbCardComponent implements OnInit {

  @Input() products;
  selectedOption;
  filterOpened: boolean;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private productsService: ProductsService) {
              }

  ngOnInit() { }

  public newProduct() {
    this.router.navigate(['../product'], { relativeTo: this.activatedRoute.parent});
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.productsService.searchProducts(event.target.value);
  }

}
